import * as React from 'react';
import { TournamentGridShortTeamData } from './TournamentGrid';
import { TOURNAMENT_SCHOOL_LOGO_FALLBACK } from 'Src/consts/tournament';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface TeamDistributedCardProps {
  team: TournamentGridShortTeamData;
  onDeleteClick: (teamId: string) => void;
  onMove: (teamId: string, direction: -1 | 1) => void;
  index: number;
  count: number;
}

export class TeamDistributedCard extends React.Component<TeamDistributedCardProps> {
  readonly SCHOOL_PICTURE_HEIGHT = 40;

  onClick = () => {
    const { team, onDeleteClick } = this.props;

    onDeleteClick(team.teamId);
  };

  render() {
    const { teamName, schoolPic, schoolName, areas } = this.props.team;
    const {index,count,onMove}=this.props;

    return (
      <div className="eTeamCard">
        <div className="eTeamCardSchoolPicWrapper">
          <img
            src={
              schoolPic
                ? `${schoolPic}?sizing=height&height=${this.SCHOOL_PICTURE_HEIGHT}`
                : TOURNAMENT_SCHOOL_LOGO_FALLBACK
            }
            alt=""
          />
        </div>
        <div className="eTeamCardTeamName">
          <strong>{teamName || 'Unnamed team'}</strong>
          <span>{schoolName || 'School not specified'}</span>
          {areas.length > 0 ? (
            <div className="eTeamCardAreas">
              {areas.map(area => (
                <span key={area}>{area}</span>
              ))}
            </div>
          ) : null}
        </div>
        <div className="eTeamCardOrder" aria-label="Round-robin team order">
          <button type="button" disabled={!index} aria-label={`Move ${teamName} up`} onClick={()=>onMove(this.props.team.teamId,-1)}><FontAwesomeIcon icon="chevron-up"/></button>
          <span>{index+1}</span>
          <button type="button" disabled={index===count-1} aria-label={`Move ${teamName} down`} onClick={()=>onMove(this.props.team.teamId,1)}><FontAwesomeIcon icon="chevron-down"/></button>
        </div>
        <button
          type="button"
          className="eTeamCardTeamAction"
          onClick={this.onClick}
          aria-label={`Remove ${teamName} from group`}
          title="Remove from group"
        >
          ×
        </button>
      </div>
    );
  }
}
